import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';

// Configuration
import { MAIN_API_URL } from '../../../configuration';

// Recharts
import { AreaChart, Area, ResponsiveContainer } from 'recharts';

// Icons
import { TrendingUp, TrendingDown } from 'lucide-react';

// Kit
import { Card } from '@/components/ui';

import { connect } from 'react-redux';

const ClicksComponent = (props) => {

    const { clicks : clicksArray  } = props;

    const { startDate, endDate } = props;

    const { error, get, response } = useFetch(`${MAIN_API_URL}/stats`, {
        headers: {
            "x-token": `${localStorage.getItem("token")}`
        }
    });

    const [data, setData] = useState([]);
    const [percentage, setPercentage] = useState(100);
    const [totalClicks, setTotalClicks] = useState('');
    // This month
    const [thisClick, setThisClick] = useState(0);
    // Last month
    const [lastClick, setLastClick] = useState(0);

    useEffect(() => { getStatsTotalClicks(); }, [startDate, endDate]);

    const getStatsTotalClicks = async () => {
        const resp = await get("/total_clicks?startDate=" + startDate + "&endDate=" + endDate);
        if (response.ok) {
                setThisClick(resp.totalClicksThisMonth);
                setLastClick(resp.totalClicksLastMonth);
                setTotalClicks(resp.totalClicks);
        } else {
            console.log(error);
        }
    }

    useEffect(() => {

        if (lastClick > 0) {
            const per = ((thisClick - lastClick) / lastClick) * 100;
            setPercentage(per.toFixed(0));
        } else {
            setLastClick(100);
        }

    }, [thisClick, lastClick])


    useEffect(() => {
        // if (data.length <= clicksArray.length) {
            const d = [];
            for (let i = 0; i < clicksArray.length; i++) {

                const newData = {
                    Name: clicksArray[i].x,
                    Clicks: clicksArray[i].y
                };

                d.push(newData);
            }

            setData([...d]);
        // } else {
        //     return;
        // }

    }, [clicksArray]);

    const isPositive = percentage > 0;
    const hasData = data.some((d) => d.Clicks > 0);

    return (
        <Card hover className="relative flex h-full min-h-[220px] flex-col overflow-hidden p-5 text-left">
            <div className="relative z-10">
                <h2 className="text-[17px] font-bold leading-tight tracking-[-0.01em] text-foreground">Clicks</h2>
                <div className="mt-3 flex items-end gap-2">
                    <span className="deck-kpi text-[2.75rem] text-foreground">{ thisClick }</span>
                    <span className={`mb-1.5 inline-flex items-center gap-0.5 text-sm font-semibold ${isPositive ? 'text-success' : 'text-danger'}`}>
                        {isPositive ? <TrendingUp size={15} /> : <TrendingDown size={15} />}
                        <span className="tabular">{isPositive ? '+' : ''}{percentage}%</span>
                    </span>
                </div>
            </div>
            {hasData && <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[42%]">
                <ResponsiveContainer>
                    <AreaChart
                        data={data}
                        margin={{
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: 0,
                        }}
                    >
                        <defs>
                            <linearGradient id="clicksGrad" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#0DA15A" stopOpacity={0.28} />
                                <stop offset="95%" stopColor="#0DA15A" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <Area type="monotone" dataKey="Clicks" stroke="#0DA15A" strokeWidth={2} fillOpacity={1} fill="url(#clicksGrad)" />
                    </AreaChart>
                </ResponsiveContainer>
            </div>}
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        startDate: state.employees.filterDates.startDate,
        endDate: state.employees.filterDates.endDate,
    }
}

export default connect(mapStateToProps, null)(ClicksComponent);
